import React from 'react';
import infoIcon from '../../../assets/info-icon.svg';
import { Col, Row} from "reactstrap";
import '../Message.css';
const infoMessage = (props) => (
    <Row className="info-msg-bg" style={{marginLeft: '0px', marginRight: '0px'}}>
        <Col sm={1} style={{paddingRight:'0px'}}> 
             <span><img src={infoIcon} className="info-i"/></span>
        </Col>
        <Col sm={11} className={props.iconLeft==='' ? ' ' : 'info-msg-ml-5'}>
          <Row><span className="info-msg-text">{(props) ? props.msg : ''}</span></Row>
          <Row><span className="info-msg-sub-text">{(props) ? props.subMsg : ''}</span></Row>
        </Col>
    </Row>)

 export default infoMessage;
